module.exports = __webpack_public_path__ + "img/lockProject.b051c8a7.svg";